import { render, staticRenderFns } from "./CustomerDocumentList.vue?vue&type=template&id=7f8fc2e2"
import script from "./CustomerDocumentList.vue?vue&type=script&lang=js"
export * from "./CustomerDocumentList.vue?vue&type=script&lang=js"
import style0 from "./CustomerDocumentList.vue?vue&type=style&index=0&id=7f8fc2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports